import { useState } from 'react';

import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Box from '@mui/material/Box';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Switch from '@mui/material/Switch';

const GeneralSignupForm = (props) => {
  const {
    formSubmitError,
    submitForm,
  } = props;

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
  });
  const [isPetOwner, setIsPetOwner] = useState(true);
  const [formEntryError, setFormEntryError] = useState({
    firstNameError: null,
    lastNameError: null,
    emailError: null,
    passwordError: null,
  });

  const handleOnChange = (event) => {
    const errorKey = `${event.target.name}Error`;
    setFormEntryError({
      ...formEntryError,
      [errorKey]: null,
    });
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };

  const validateFormData = () => {
    const error = {
      firstNameError: null,
      lastNameError: null,
      emailError: null,
      passwordError: null,
    };
    if (!formData.firstName) {
      error.firstNameError = 'First name is required';
    }
    if (!formData.lastName) {
      error.lastNameError = 'Last name is required';
    }
    if (!formData.email) {
      error.emailError = 'Email is required';
    }
    if (!formData.password) {
      error.passwordError = 'Password is required';
    }
    setFormEntryError(error);
    return Object.keys(error).reduce(
      (prevVal, key) => prevVal && error[key] === null,
      true
    );
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const isDataValid = validateFormData();
    if (!isDataValid) return;
    submitForm({ isPetOwner, ...formData });
  };

  const PetOwnerSwitch = () => (
    <Switch
      name="isPetOwner"
      color="secondary"
      checked={isPetOwner}
      onChange={e => setIsPetOwner(e.target.checked)}
    />
  );

  return (
    <Container
      component="main"
      maxWidth="xs"
      sx={{
        height: 'calc(100vh - 100px)',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
          <PersonOutlineIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign Up
        </Typography>
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
          <div>
            <TextField
              margin="normal"
              sx={{ width: 'calc(50% - 0.25em)', mr: '0.5em' }}
              id="firstName"
              label="First name"
              name="firstName"
              autoComplete="given-name"
              autoFocus
              value={formData.firstName}
              onChange={handleOnChange}
              error={formEntryError.firstNameError !== null}
              helperText={formEntryError.firstNameError}
            />
            <TextField
              margin="normal"
              sx={{ width: 'calc(50% - 0.25em)' }}
              id="lastName"
              label="Last name"
              name="lastName"
              autoComplete="family-name"
              value={formData.lastName}
              onChange={handleOnChange}
              error={formEntryError.lastNameError !== null}
              helperText={formEntryError.lastNameError}
            />
          </div>
          <TextField
            margin="normal"
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            value={formData.email}
            onChange={handleOnChange}
            error={formEntryError.emailError !== null}
            helperText={formEntryError.emailError}
          />
          <TextField
            margin="normal"
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="new-password"
            value={formData.password}
            onChange={handleOnChange}
            error={formEntryError.passwordError !== null}
            helperText={formEntryError.passwordError}
          />
          <FormControlLabel
            control={<PetOwnerSwitch />}
            label={isPetOwner ? 'Pet owner' : 'Pet sitter'}
            sx={{ mt: 1.5 }}
          />
          {formSubmitError && (
            <Alert severity="error" sx={{ mt: 1 }}>{formSubmitError}</Alert>
          )}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Next
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default GeneralSignupForm;
